/* eslint @typescript-eslint/no-explicit-any: 0 */
export default (k, m) => m[k] || m.default;
//# sourceMappingURL=switcher.mjs.map